import React from 'react';
import { NavLink } from 'react-router-dom';

export default function BottomNav() {
  return (
    <nav className="mp-bottom-nav">
      <NavLink to="/" end className="mp-nav-item">
        <span className="mp-nav-icon" aria-hidden>
          🎬
        </span>
        <span className="mp-nav-label">Pick</span>
      </NavLink>
      <NavLink to="/watchlist" className="mp-nav-item">
        <span className="mp-nav-icon" aria-hidden>
          ★
        </span>
        <span className="mp-nav-label">Watchlist</span>
      </NavLink>
    </nav>
  );
}
